import tooltip from 'common/utils/tooltip';

class TableController {
  constructor() {
    this.tooltip = tooltip;
  }

  getTableStyle(config) {
    let style = {};
    if (config.fullWidth) {
      style.width = '100%';
    }
    return style;
  }

  getThStyle(header) {
    let style = {};
    if (header.width) {
      style.width = header.width;
      style.maxWidth = header.width;
    }
    return style;
  }
}

export default TableController;



// WEBPACK FOOTER //
// ./client/app/components/table/table.controller.js